import React, { useState } from 'react'
import { dadosSuporteService } from '../../services/Dados-Suporte-Service/dados-suporte-service'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Button, Col, Form, Input, Popconfirm, Row, Select, message } from 'antd'
import './styles.css'
import ConsultaComponent from '../../components/Consulta/consulta-component'
import { FiltroConsultaModel } from '../../models/filtro-consulta-model'
import ModalDadosSuporte from '../../components/ModalDadosSuporte'

interface colunas {
  title?: string,
  dataIndex?: string,
  key?: string,
  width?: number,
  align?: string
  render?: any,
  fixed?: any
}

const DadosSuporte: React.FC<any> = () => {

  const [formPesquisa] = Form.useForm();
  const [dados, setDados] = useState([]);
  const [colunas, setColunas] = useState<colunas[]>();
  const [loading, setLoading] = useState(false)
  const [visibleModalDadosSuporte, setVisibleModalDadosSuporte] = useState(false)
  const [modalDadosSuporte, setModalDadosSuporte] = useState<{ ehEdicao: boolean, objeto: any | null, tabelaSelecionada: string }>({ ehEdicao: false, objeto: null, tabelaSelecionada: "" })

  let colunasTable: colunas[] = []

  const tabelasDadoSuporte = [
    { tabela: 'escolaridade', descricao: 'Escolaridade' },
    { tabela: 'meioComunicacao', descricao: 'Meio Comunicacao' },
    { tabela: 'instituicaoEncaminhamento', descricao: 'Instituição de Encaminhamento' },
    { tabela: 'motivoEscolaridade', descricao: 'Motivo de Escolaridade' },
    { tabela: 'ocupacao', descricao: 'Profissional' }
  ]

  const htmlButtons = (
    <Button type='primary' style={{ marginBottom: '15px' }} onClick={() => setVisibleModalDadosSuporte(true)} >Novo Dado</Button>
  )

  const opicoesDeFiltros: FiltroConsultaModel[] = [

    {
      name: 'tabela',
      label: 'Tipo do Dado Suporte',
      componentChild: <Select placeholder="Selecione" onChange={(e: any) => changeTabela(e)}>
        {tabelasDadoSuporte.map((t, index) => {
          return <Select.Option key={index} value={t.tabela}>{t.descricao}</Select.Option>
        })}
      </Select>,
      required: true
    },
    {
      name: 'nome',
      label: 'Nome',
      componentChild: <Input placeholder="Digite o nome do Dado Suporte" />,
      required: false
    }

  ]

  function changeTabela(e: any) {
    colunasTable = [];
    dadosSuporteService.getPropertiesByTabela(e).then((resp) => {
      resp.data?.map((c: any, index: any) => {
        if (c.colunaConsulta != null) {
          colunasTable?.push({
            dataIndex: c.formName,
            title: c.colunaConsulta,
            align: 'left',
            width: 200,
            key: index
          })
        }
      })
      colunasTable.push({
        width: 100,
        title: "Ações",
        render: (text: any, record: any) => (
          <div className='btnArea'>
            <Popconfirm key={record.entidadeID} placement="top" title={`Você tem certeza que deseja ${record.ativo == true ? "inativar" : "ativar"} esse registro?`} onConfirm={() => { ativarDesativarEntidade(record); }} okText="Sim" cancelText="Não">
              <Button type="primary" key={record.entidadeID} danger={record.ativo == true ? true : false}>  {record.ativo == true ? "Inativar" : "Ativar"} </Button>
            </Popconfirm>
            <Button onClick={() => { setVisibleModalDadosSuporte(true); setModalDadosSuporte({ ehEdicao: true, objeto: record, tabelaSelecionada: formPesquisa.getFieldValue("tabela") }) }}> Editar</Button>
          </div>
        ),
      })
    }).finally(() => {
      setColunas(colunasTable)
      pesquisar()
    })
  }

  const ativarDesativarEntidade = (entidade: any) => {

    let objeto = { ...entidade }

    objeto.ativo = !objeto.ativo

    dadosSuporteService.put(objeto, formPesquisa.getFieldValue('tabela')).then((resp) => {
      message.success(objeto.ativo == true ? "Dado suporte ativado com sucesso" : "Dado suporte inativado com sucesso")
      pesquisar()
    })
      .catch((err: any) => {
        message.error(err?.response?.data?.error[0] || "Erro inesperado")
      })
  }

  const pesquisar = () => {
    let dadosSuporte = {
      nome: formPesquisa.getFieldValue('nome'),
      descricao: formPesquisa.getFieldValue('nome'),
      titulo: formPesquisa.getFieldValue('nome')
    }
    setLoading(true)
    dadosSuporteService
      .postComFiltro(dadosSuporte, formPesquisa.getFieldValue('tabela'))
      .then((response: any) => {
        setDados(response.data)
      })
      .finally(() => (setLoading(false)))

  }


  return (
    <>
      <Header />
      <br />
      <ConsultaComponent
        colunasTable={colunas}
        dadosTable={dados}
        scrollTable={{ x: 100, y: 400 }}
        pageSizeTable={15}
        legendaStatus={htmlButtons}
        rowKeyTable={formPesquisa.getFieldValue('tabela') + "ID"}
        filtros={opicoesDeFiltros}
        pesquisar={pesquisar}
        form={formPesquisa}
        loading={loading}
        indicesFiltrosPreSelecionados={[0, 1]}
      />
      <Footer />
      <ModalDadosSuporte fecharModal={() => { setModalDadosSuporte({ ehEdicao: false, objeto: null, tabelaSelecionada: "" }); setVisibleModalDadosSuporte(false) }} visible={visibleModalDadosSuporte}
        atualizarConsulta={() => {
          pesquisar()
        }}
        modal={modalDadosSuporte} />
    </>

  )
}

export default DadosSuporte